/*Update Or Create Array By _id*/
Array.prototype.removeById = function(id) {
    let foundIndex = this.findIndex((p) => {
        if (p._id === id) return true;
        else return false;
    });
    if (foundIndex === -1) {
        console.error(`removeById Error: Object with id ${id} not found`, this);
    } else {
        this.splice(foundIndex, 1);
    }

}